import type React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { scrollAnimation } from '../../utils/animations';

interface SectionProps {
  id: string;
  className?: string;
  children: React.ReactNode;
  noPadding?: boolean;
  bgColor?: 'white' | 'gray' | 'primary' | 'primary-light';
}

const Section: React.FC<SectionProps> = ({
  id,
  className = '',
  children,
  noPadding = false,
  bgColor = 'white',
}) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const bgClasses = {
    white: 'bg-white',
    gray: 'bg-gray-100',
    primary: 'bg-primary text-white',
    'primary-light': 'bg-primary/5',
  };

  const paddingClasses = noPadding ? '' : 'py-16 md:py-24';

  return (
    <motion.section
      id={id}
      ref={ref}
      className={`${paddingClasses} ${bgClasses[bgColor]} ${className}`}
      variants={scrollAnimation}
      initial="hidden"
      animate={inView ? 'visible' : 'hidden'}
    >
      <div className="container mx-auto px-6 lg:px-8">
        {children}
      </div>
    </motion.section>
  );
};

export default Section;
